import { Product } from '@/services/product/types';
import api from '..';

type VendingMachineAttributes = {
  address: string;
  instructions: string;

  /**
   * Номер в 1С
   */
  erp_id: string;

  Coordinates: {
    coordinates: {
      lat: number;
      lng: number;
    };
  };

  image?: {
    data: {
      id: number;
      attributes: {
        url: string;
        width?: number;
        height?: number;
        size?: number;
      };
    };
  };

  instruction_image?: {
    data: {
      id: number;
      attributes: {
        url: string;
        width?: number;
        height?: number;
        size?: number;
      };
    };
  };
};

export type VendingMachine = {
  id: number;
  attributes: VendingMachineAttributes;
};

export async function getVendingMachines() {
  const response = await api.get<{
    data: VendingMachine[];
  }>('/machines', {
    params: {
      pagination: {
        limit: 10000
      },
      filters: {
        is_active: true
      }
    }
  });

  return response.data.data;
}

export type VendingMachineWithProduct = {
  id: number;
  attributes: VendingMachineAttributes & {
    products: {
      in_stock: number;
      product: {
        data: Product;
      };
    }[];
  };
};

export async function getVendingMachinesForProduct(productId: string) {
  const response = await api.get<{
    data: VendingMachineWithProduct[];
  }>(`/machines/by-product/${productId}`);

  return response;
}

export async function getVendingMachine(id: string) {
  return api.get<{
    data: VendingMachine;
  }>(`/machines/${id}`, {
    params: {
      populate: ['products.product', 'image', 'instruction_image']
    }
  });
}

export async function getVendingMachineByCoordinates(lng: number, lat: number) {
  const response = await api.get<{
    data: VendingMachine[];
  }>(`/machines/by-locality`, {
    params: {
      lat,
      lng
    }
  });

  return response.data.data;
}
